module.exports = __webpack_public_path__ + "media/images/top/icon/orange/ico_tel-21a4e57f8f531263c0928e12bf840ff8.svg";